module.exports = __webpack_public_path__ + "img/_1.3234e903.png";